export default "__VITE_ASSET__o0_t9V5e__"